<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  color="primary lighten-5"
)
  v-container(fluid)
    v-row(justify="center" align="center")
      v-col(cols="auto")
        v-row(justify="center")
          v-col(cols=12 sm=8 md=12)
            h3.text-center.mb-12.mb-md-14.ibm.text-h4.text-md-h3.primary--text Empresas que já usam a plataforma
        v-row(justify="center" align="center")
          v-col(v-for="card in cards" cols="auto" :key="card.id")
            v-card.rounded-lg.py-4(
              min-width=240
              max-width=272
              outlined
              style="border: 1px solid #757575"
            )
              v-container
                v-row(align="center" justify="center")
                  v-col(cols="auto")
                    v-img.mb-2(:src="card.image" width=144 height=144)
                      template(#placeholder)
                        v-sheet.rounded-circle(
                          color="grey lighten-4"
                          width=144
                          height=144
                        )
                  v-col(cols="auto")
                    .mb-3.text-center.text-body-1.text-md-h6.font-weight-regular.ibm.primary--text {{ card.title }}
                    .mb-8.text-body-2.text-md-body-1.heebo {{ card.subtitle }}
                    v-btn.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
                      color="primary accent-2"
                      outlined
                      height=48
                    ) Ir para o site
        v-row(justify="center" align="center")
          v-col(cols=12 sm="auto")
            v-btn.mt-4.mt-md-8.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
              color="primary accent-2"
              depressed
              :block="$vuetify.breakpoint.smAndDown"
              height=56
              @click="$goTo({ path: '/', target: '#selectInst' })"
            ) Quero me tornar um parceiro
</template>

<script>
export default {
  components: {},
  data() {
    return {
      cards: [
        {
          id: 0,
          image: '',
          title: 'IEPSIS',
          subtitle: 'Descrição da empresa',
          action: () => {}
        },
        {
          id: 1,
          image: '',
          title: 'IEPSIS',
          subtitle: 'Descrição da empresa',
          action: () => {}
        },
        {
          id: 2,
          image: '',
          title: 'IEPSIS',
          subtitle: 'Descrição da empresa',
          action: () => {}
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped></style>
